import { FieldSpec } from '@k2/common/k2-forms-state/types';

export function textFormatter(field: FieldSpec): string {
  return field.value;
}
